import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlideWideAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSlideWideAdd"><Path fillRule="evenodd" clipRule="evenodd" d="M22 4H2V20H22V4ZM13 8H11V11H8V13H11V16H13V13H16V11H13V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSlideWideAdd;
